module.exports = __webpack_public_path__ + "static/media/tortoise03.decc3486.svg";